import { authClient } from './client';
import type { MagicLinkVerifyResponse } from '../types';

export const verifyMagicLink = async (token: string): Promise<MagicLinkVerifyResponse> => {
  const { data } = await authClient.post<MagicLinkVerifyResponse>('/auth/magic-link/verify', { token });
  return data;
};
